<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar :slot="tabPosition">
        <ion-tab-button tab="calendar" href="/calendar">
          <ion-icon :icon="calendarOutline" />
          <ion-label>Eventi</ion-label>
        </ion-tab-button>
          
        <ion-tab-button tab="map" href="/map">
          <ion-icon :icon="earthOutline" />
          <ion-label>Impianti</ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="user" href="/user">
          <ion-icon :icon="personOutline" />
          <ion-label>Profilo</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="settings" href="/settings">
          <ion-icon :icon="settingsOutline" />
          <ion-label>Impostazioni</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet, useIonRouter } from '@ionic/vue';
import { earthOutline, personOutline, settingsOutline, calendarOutline } from 'ionicons/icons';
import { isPlatform } from '@ionic/vue';

export default defineComponent({
  name: 'TabsPage',
  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonPage, IonRouterOutlet },
  setup() {

    const router = useIonRouter()

    /* inserire qui l'hardware back button */

    return {
      earthOutline, 
      personOutline, settingsOutline, 
      calendarOutline,
    }
  },
  data () {
    return {
      tabPosition: isPlatform('desktop') ? 'top' : 'bottom'
    }
  },
});
</script>
